import { useMemo, useState } from 'react'
import { getPeriodoMesAtual } from '../../../../services/util/date.service'
import { errorHandler } from '../../../../services/util/error.service'
import * as UtlHttp from '../../../../services/api/https/patio/tomada-utilizacao.http'
import * as TomadaHttp from '../../../../services/api/https/patio/tomada.http'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  INITIAL_GET: 'Carregando movimentações',
}

export const MENU_ITEMS = ['1. Editar', '2. Finalizar Utilização', '3. Emitir Ticket']

const INITIAL_STATE = {
  movs: [],
  modal: { show: false, data: null },
  modalConfirmFinalize: { show: false, data: null },
  tomadas: [],
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  selectedTp: 0,
  globalFilter: '',
  periodo: { inicial: getPeriodoMesAtual().dataInicial, final: getPeriodoMesAtual().dataFinal },
  isLoadingTable: false,
}

export default function useUtilizacoes() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      async loadTomadas(tp_id) {
        try {
          const list = tp_id ? await TomadaHttp.getTomadasActived(tp_id) : []
          setState(prev => ({ ...prev, tomadas: list || [] }))
        } catch (err) {
          setState(prev => ({ ...prev, errorMessage: errorHandler(err) }))
        }
      },
      async getUtilizacoes({ tp_id, pInicial, pFinal }) {
        try {
          setState(prev => ({ ...prev, isLoadingTable: true }))
          const list = await UtlHttp.getUtilizacoes({ tp_id, pInicial, pFinal })
          setState(prev => ({
            ...prev,
            movs: list || [],
            loadingMessage: LOAD_MESSAGE.NONE,
            errorMessage: null,
            periodo: { ...prev.periodo },
            isLoadingTable: false,
          }))
        } catch (err) {
          setState(prev => ({
            ...prev,
            loadingMessage: LOAD_MESSAGE.NONE,
            errorMessage: errorHandler(err),
            isLoadingTable: false,
          }))
        }
      },
      async onPesquisar({ tp_id, pInicial, pFinal }) {
        if (!tp_id) {
          setState(prev => ({ ...prev, errorMessage: 'Selecione um TP' }))
          return
        }
        await localDispatch.getUtilizacoes({ tp_id, pInicial, pFinal })
      },
      onInit(selectedTp) {
        setState(prev => ({
          ...prev,
          selectedTp: selectedTp,
          loadingMessage: selectedTp ? LOAD_MESSAGE.INITIAL_GET : LOAD_MESSAGE.NONE,
          errorMessage: selectedTp ? null : 'Selecione um TP',
        }))
        if (selectedTp) {
          localDispatch.loadTomadas(selectedTp)
        } else {
          setState(prev => ({ ...prev, tomadas: [] }))
        }
      },
      onBtnNovo() {
        setState(prev => ({ ...prev, modal: { show: true, data: null } }))
      },
      onModalClose() {
        setState(prev => ({ ...prev, modal: { show: false, data: null } }))
      },
      onRowClick(utl) {
        if (utl.status === 'Finalizada') {
          setState(prev => ({
            ...prev,
            errorMessage: 'Utilização finalizada não pode ser editada.',
          }))
          return
        }
        setState(prev => ({ ...prev, modal: { show: true, data: utl } }))
      },
      async onModalSave(saved) {
        setState(prev => {
          const copy = { ...prev, modal: { show: false, data: null } }
          const idx = copy.movs.findIndex(m => m.id === saved.id)
          if (idx >= 0) copy.movs[idx] = saved
          else copy.movs = [saved, ...copy.movs]
          return copy
        })
      },
      async onFinalizar(id) {
        try {
          const updated = await UtlHttp.finalizarUtilizacao(id)
          setState(prev => {
            const copy = { ...prev }
            const idx = copy.movs.findIndex(m => m.id === updated.id)
            if (idx >= 0) copy.movs[idx] = updated
            return copy
          })
        } catch (err) {
          setState(prev => ({ ...prev, errorMessage: errorHandler(err) }))
          throw err
        }
      },
      onGlobalFilterChange(value) {
        setState(prev => ({ ...prev, globalFilter: value }))
      },
      onConfirmFinalizarOpen(mov) {
        setState(prev => ({ ...prev, modalConfirmFinalize: { show: true, data: mov } }))
      },
      onConfirmFinalizarClose() {
        setState(prev => ({ ...prev, modalConfirmFinalize: { show: false, data: null } }))
      },
    }
  }, [])

  return { state, localDispatch }
}
